import Vue from "vue";
import { ir } from "./check_domain_ir";
import i18n from "./i18n.js";
import JwtService from "./core/plugins/TitleRibbon/assets/js/jwt.service";
import router from "./router";
import { LOGOUT } from "@/core/services/store/auth.module";
import store from "@/core/services/store";
import { mapGetters } from "vuex";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import ax from "./axiosMeth.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import moment from "moment-jalaali";
import { Data } from "./core/plugins/TitleRibbon/plugins/EasyModal/store/global/index.js";

let coreland = ir(process.env.VUE_APP_CoreLandUrl);
let payamakland = ir(process.env.VUE_APP_PayamakLandURL);
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA3_SITE });
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

const Mixin = {
  mounted() {
    $("input[name='table-search']")
      .parent()
      .removeClass("offset-md-6")
      .addClass("ms-auto");
    // this.getSpecialmenu();
    // start filters
    Vue.filter("currency", (x) => {
      if (!x) return "-";

      let locale;
      switch (i18n.locale) {
        case "fa":
          locale = "fa-IR"; // فارسی
          break;
        case "ar":
          locale = "ar-IQ"; // عربی عراق
          break;
        case "en":
          locale = "en-US"; // انگلیسی
          break;
        default:
          locale = "fa-IR"; // فارسی
      }
      return new Intl.NumberFormat(locale, { style: "decimal" }).format(x);
    });

    // Vue.filter("timeAgo", (value) => {
    //   moment(value).fromNow();
    // });
    Vue.filter("timeAgo", (value) => {
      if (!value) return "-";
      let locale;
      switch (i18n.locale) {
        case "fa":
          locale = "fa";
          moment.loadPersian({ dialect: "persian-modern" });
          break;
        case "ar":
          locale = "ar"; // عربی
          break;
        default:
          locale = "en";
      }
      moment.locale(locale);
      return moment(value).fromNow();
    });
    Vue.filter("longDate", (value) => {
      let locale;
      switch (i18n.locale) {
        case "fa":
          locale = "fa";
          moment.loadPersian({ dialect: "persian-modern" });
          break;
        case "ar":
          locale = "ar"; // عربی
          break;
        default:
          locale = "en";
      }
      moment.locale(locale);
      return moment(value).format(
        i18n.locale === "fa" ? "HH:mm jYYYY-jM-jD" : "HH:mm YYYY-M-D",
      );
    });

    // Vue.filter("longDate", (value) =>
    //   moment(value).format("HH:mm jYYYY-jM-jD")
    // );

    Vue.filter("rial", (value) =>
      value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    );
    Vue.filter("stringDate", (input) => {
      try {
        const locale = i18n.locale;
        moment.locale(locale === "fa" ? "fa" : locale === "ar" ? "ar" : "en");

        if (locale === "fa") {
          moment.loadPersian({ dialect: "persian-modern" });
        }
        const formatPatterns = {
          fa: "dddd LL HH:mm:ss",
          ar: "dddd, LL HH:mm:ss",
          en: "dddd, MMMM D, YYYY HH:mm:ss",
        };

        return moment(input, "YYYY-M-D HH:mm:ss").format(
          formatPatterns[locale] || formatPatterns.en,
        );
      } catch (e) {
        return input;
      }
    });
    // Vue.filter("stringDate", function (input) {
    //   try {
    //     // let moment = require('moment-jalaali')
    //     moment.loadPersian({ dialect: "persian-modern" });
    //     return moment(input, "YYYY-M-D HH:mm:ss").format("dddd LL HH:mm:ss");
    //   } catch (e) {}
    // });

    Vue.filter("persianNum", function (input) {
      try {
        if (input === undefined || input == null) return "";
        let str1 = input.toString().trim();
        if (str1 === "") return "";
        str1 = str1.replace(/0/gim, "۰");
        str1 = str1.replace(/1/gim, "۱");
        str1 = str1.replace(/2/gim, "۲");
        str1 = str1.replace(/3/gim, "۳");
        str1 = str1.replace(/4/gim, "۴");
        str1 = str1.replace(/5/gim, "۵");
        str1 = str1.replace(/6/gim, "۶");
        str1 = str1.replace(/7/gim, "۷");
        str1 = str1.replace(/8/gim, "۸");
        str1 = str1.replace(/9/gim, "۹");
        return str1;
      } catch (e) {}
    });

    Vue.filter("userType", (value) => {
      if (value === "legal") return i18n.t("filters.userType.legal");
      return i18n.t("filters.userType.individual");
    });

    Vue.filter("isEmpty", (val) => {
      return val ? val : "";
    });

    Vue.filter("serviceType", (val) => {
      if (val === "Payamakland")
        return i18n.t("filters.serviceType.Payamakland");
      else if (val === "Coreland")
        return i18n.t("filters.serviceType.Coreland");
      else if (val === "Qrland") return i18n.t("filters.serviceType.Qrland");
      else if (val === "Robotland")
        return i18n.t("filters.serviceType.Robotland");
      else if (val === "billboard")
        return i18n.t("filters.serviceType.billboard");
      else if (val === "tablighNegar")
        return i18n.t("filters.serviceType.tablighNegar");
      else return i18n.t("filters.serviceType.unknown");
    });

    Vue.filter("expireColor", (exp) => {
    if (exp === "expired") return "in-expire";

    if (typeof exp === "number") {
        if (exp > 30) return "";
        if (exp <= 30 && exp > 15) return "in-month";
        if (exp <= 15 && exp >= 1) return "in-days";
        return "in-expire";
    }

    if (typeof exp === "object") {
        if (exp.unit === "day") {
            if (exp.value > 30) return "";
            if (exp.value <= 30 && exp.value > 15) return "in-month";
            if (exp.value <= 15 && exp.value >= 1) return "in-days";
        } 
        else if (["hour", "minute"].includes(exp.unit)) {
            return "in-days";
        }
    }

    return "in-expire";
});

    Vue.filter("untilExpire", (exp) => {
      return this.getUntilExpire(exp);
    });

    Vue.filter("typeText", (time, text = true) => {
      return this.getTypeText(time, text);
    });

    Vue.filter("persianNumber", (value) => {
      return value.toPersianLetter();
    });

    Vue.filter("numericPersianNumber", (value) => {
      if (value < 1_000_000)
        return `${value / 1_000} ${i18n.t(
          "filters.numericPersianNumber.thousand",
        )}`;

      return `${value / 1_000_000} ${i18n.t(
        "filters.numericPersianNumber.million",
      )}`;
    });

    Vue.filter("getProductImage", (item) => {
      try {
        if (!!item)
          if (typeof item === "string") {
            let obj = JSON.parse(item);
            return obj?.[0]?.images[0]?.url || "";
          }
      } catch (e) {
        console.log(e);
      }

      return "";
    });
    // end filters
  },
  methods: {
    ...ax,
    datediff(first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24));
    },
    async generateRecaptchaToken(action) {
      await this.$recaptchaLoaded();
      return await this.$recaptcha(action);
    },
    coreLandApi(url) {
      return coreland + `/storage/${url}`;
    },
    toggleNavigation() {
      this.$store.dispatch("menu/toggle");
    },
    toggleMobileMenu() {
      this.$store.dispatch("menu/toggle");
      // this.$store.dispatch('menu/toggleMobile');
    },
    cloneObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    firstLetter(input) {
      if (!input) return "U";
      return input.charAt(0).toUpperCase().toString();
    },
    fixLink(link) {
      return link?.startsWith("http") ? link : "https://" + link;
    },
    getUntilExpire(exp) {
      const moment = require("moment-jalaali");
      const now = new Date();
      let diffSeconds = moment(exp).diff(now, "seconds");

      if (diffSeconds < 0) {
        return "expired";
      }

      let diffDays = moment(exp).diff(now, "days");
      if (diffDays >= 1) {
        return { value: diffDays, unit: "day" };
      }

      let diffHours = moment(exp).diff(now, "hours");
      if (diffHours >= 1) {
        return { value: diffHours, unit: "hour" };
      }

      let diffMinutes = moment(exp).diff(now, "minutes");
      return { value: diffMinutes > 0 ? diffMinutes : 1, unit: "minute" };
    },
      
    getTypeText(time, text = true) {
      if (time === "expired") {
        return i18n.t("filters.expire.expired");
      }

      if (typeof time === "object") {
        let unitText = "";

        switch (time.unit) {
          case "day":
            unitText = i18n.t("filters.expire.day");
            break;
          case "hour":
            unitText = i18n.t("hour");
            break;
          case "minute":
            unitText = i18n.t("minute");
            break;
        }

        return text
          ? `${this.persian(time.value)} ${unitText} ${i18n.t("remaining")}`
          : unitText;
      }
    },

    async getUserTokenWithId(id) {
      let response = await this.requestApiPost("admin/userLogin", {
        user_id: id,
      });
      if (response.data.token) {
        return response.data.token;
      } else {
        throw new DOMException("to token found");
      }
    },
    authority() {
      this.requestApiGet("user")
        .then(({ data }) => {
          localStorage.setItem("userInfo", JSON.stringify(data));
          store.dispatch("setUser", data);
        })
        .catch(({ response }) => {
          if (response.status === 401) {
            this.logout();
          }
        });
    },
    logout() {
      i18n.toast.warning(i18n.t("filters.messages.pleaseLogin"));
      return this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    configurationFile() {
      return {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function (progressEvent) {
          this.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          this.$forceUpdate();
        }.bind(this),
      };
    },
    getTime: function (input) {
      try {
        let time = input.split(" ")[1].split(":");
        return time[0] + ":" + time[1];
      } catch (e) {
        return input;
      }
    },
    jalalian: function (input, type = "date", sp = "/") {
      try {
        let moment = require("moment-jalaali");
        let date = moment(
          input,
          type === "date"
            ? `YYYY${sp}MM${sp}DD`
            : `YYYY${sp}MM${sp}DD HH:mm:ss`,
        );
        return date.format(
          type === "date"
            ? `jYYYY${sp}jMM${sp}jDD`
            : `jYYYY${sp}jMM${sp}jDD HH:mm:ss`,
        );
      } catch (e) {
        console.log("jalali error: ", e);
        return input;
      }
    },
    // no set i18n for this function
    datetime(input, type) {
      if (!input || !input.length) return "-";
      if (type === "datetime") {
        return `${this.jalalian(input)} ${this.getTime(input)}`;
      } else {
        return `${this.jalalian(input)}`;
      }
    },

    dateString(input) {
      try {
        const locale = i18n.locale;
        moment.locale(locale === "fa" ? "fa" : locale === "ar" ? "ar" : "en");

        if (locale === "fa") {
          moment.loadPersian({ dialect: "persian-modern" });
        }

        const dateFormatPatterns = {
          fa: "dddd LL",
          ar: "dddd, LL",
          en: "dddd, MMMM D, YYYY",
        };

        const datePart = moment(input, "YYYY-M-D").format(
          dateFormatPatterns[locale] || dateFormatPatterns.en,
        );
        const timePart = moment(input, "YYYY-M-D HH:mm:ss").format("LT");

        return `${datePart} ${i18n.t("filters.dateString.at")} ${timePart}`;
      } catch (e) {
        return input;
      }
    },
    dateDiffNow(input) {
      try {
        let moment = require("moment-jalaali");
        moment.loadPersian({ dialect: "persian-modern" });
        return moment(input).fromNow();
      } catch (e) {
        return input;
      }
    },
    nowDateTimeString(sp = "-", type = "datetime") {
      let moment = require("moment-jalaali");
      let res = "";
      if (type === "date") {
        res = moment().format(`YYYY${sp}MM${sp}DD`);
      } else if (type === "time") {
        res = moment().format(`HH:mm:ss`);
      } else {
        res = moment().format(`YYYY${sp}MM${sp}DD HH:mm:ss`);
      }
      return res;
    },
    openLink(url) {
      let a = document.createElement("a");
      // a.target = '_blank';
      a.href = url;
      a.click();
    },
  async checkTokenAsync(token) {
  try {
    let res = await axios.get(`${this.$sarveLand}/api/user`, {
      headers: { Authorization: `Bearer ${token}`,
                secret: process.env.VUE_APP_CoreSecret,},
    });

    if (res.status === 200) {
      
      try {
        let resValid = await axios.get(`${this.$sarveLand}/api/user/validation`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        if (resValid.status === 200) {
          localStorage.setItem("user_info", JSON.stringify(res.data));
          this.$store.dispatch("setUser", res.data);

        }
      } catch (validError) {
        if (validError.response && validError.response.status === 400) {
          this.$root.$emit("open-address-popup");
        } 
        else if (validError.response && validError.response.status === 401) {
          throw validError; 
        }
      }

    }
  } catch (e) {
    if (e.response && e.response.status === 401) {
      this.$store
        .dispatch(LOGOUT)
        .then(() => window.location.replace(`${this.$sarveLandFront}`));
    }
  }
},

    getSpecialmenu() {
      $.ajax({
        url: `${url}/user/menus`,
        type: "GET",
        fn: this.getSpecialmenu,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (data) => {
          this.$store.dispatch("menu/items", data.data);
        },
      });
    },
    getUserStatus() {
      let status = this.getUser();
      return status.auth_validate;
    },
    getUser() {
      //TODO: delete id and private fields
      return JSON.parse(localStorage.getItem("userInfo"));
    },
    getWallet() {
      return JSON.parse(localStorage.getItem("user_wallet"));
    },
    checkWallet() {
      let walletInfo = "";
      axios
        .post(
          `${coreland + "/api"}/wallet`,
          {},
          {
            headers: this.header(),
          },
        )
        .then(({ data }) => {
          if (data.currency === "Rial") {
            walletInfo = this.changeMoney("rial");
          }
          if (data.currency === "Toman") {
            walletInfo = this.changeMoney("toman");
          }
          if (data.currency === "Dollar") {
            walletInfo = this.changeMoney("dollar");
          }
          if (data.currency === "Euro") {
            walletInfo = this.changeMoney("euro");
          }
          if (data.currency === "Bitcoin") {
            walletInfo = this.changeMoney("bitcoin");
          }
          if (data.currency === "Ethereum") {
            walletInfo = this.changeMoney("ethereum");
          }
          let user_wallet = {
            icon: walletInfo.icon,
            color: walletInfo.color,
            balance: data.balance,
          };
          localStorage.setItem("user_wallet", JSON.stringify(user_wallet));
          this.$store.dispatch("wallet/setWallet", user_wallet);
        })
        .catch(({ response }) => {
          if (response.status === 401) {
            this.logout();
          }
        });
    },
    changeMoney(data) {
      return {
        icon: money.data[data].icon,
        color: money.data[data].color,
        value: money.data[data].value,
      };
    },
    goto(route, query = {}) {
      router.push({ path: "/" + route, query: query });
    },
    goReplace(route) {
      router.replace({ path: "/" + route });
    },
    toggleNightMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.setCookie("theme", this.$vuetify.theme.dark, "60");
    },
    setCookie(cname, cvalue, exdays) {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname, def = "") {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return def;
    },
    header() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    payamakHeader() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    requestApiGet(uri, queries = {}) {
      return axios.get(`${coreland + "/api"}/${uri}`, {
        headers: this.header(),
        params: queries,
      });
    },
    requestApiGetPayamak(uri, queries = {}) {
      return axios.get(`${payamakland + "/api"}/${uri}`, {
        headers: this.payamakHeader(),
        params: queries,
      });
    },
    requestApiPostPayamak(uri, data = {}) {
      return axios.post(`${payamakland + "/api"}/${uri}`, data, {
        headers: this.payamakHeader(),
      });
    },
    requestApiPost(uri, data = {}) {
      return axios.post(`${coreland + "/api"}/${uri}`, data, {
        headers: this.header(),
      });
    },
    requestApiPostLogin(uri, data = {}) {
      return axios.post(`${coreland + "/api"}/${uri}`, data);
    },
    requestApiPut(uri, data = {}, queries = {}) {
      return axios.put(`${coreland + "/api"}/${uri}`, data, {
        headers: this.header(),
        params: queries,
      });
    },
    requestApiDelete(uri, queries = {}) {
      return axios.delete(`${coreland + "/api"}/${uri}`, {
        headers: this.header(),
        params: queries,
      });
    },
    validateInput(input) {
      if (input === undefined || input == null) return "";
      let str = input.toString().trim();
      if (str === "") return "";
      return str;
    },

    use_lang(input) {
      let lang = i18n.locale || "fa";
      let str1 = validateInput(input);
      if (typeof str1 !== "string") str1 = str1 == null ? "0" : str1.toString();
      switch (lang) {
        case "fa":
          str1 = persian(str1);
          break;
        case "en":
          str1 = english(str1);
          break;
        case "ar":
          str1 = arabic(str1);
          break;

        default:
          str1 = persian(str1);
          break;
      }
      return str1;
    },
    persian(input) {
      let str1 = this.validateInput(input);
      // تبدیل اعداد انگلیسی به فارسی
      str1 = str1.replace(/0/gim, "۰");
      str1 = str1.replace(/1/gim, "۱");
      str1 = str1.replace(/2/gim, "۲");
      str1 = str1.replace(/3/gim, "۳");
      str1 = str1.replace(/4/gim, "۴");
      str1 = str1.replace(/5/gim, "۵");
      str1 = str1.replace(/6/gim, "۶");
      str1 = str1.replace(/7/gim, "۷");
      str1 = str1.replace(/8/gim, "۸");
      str1 = str1.replace(/9/gim, "۹");
      // تبدیل اعداد عربی به فارسی
      str1 = str1.replace(/٠/gim, "۰");
      str1 = str1.replace(/١/gim, "۱");
      str1 = str1.replace(/٢/gim, "۲");
      str1 = str1.replace(/٣/gim, "۳");
      str1 = str1.replace(/٤/gim, "۴");
      str1 = str1.replace(/٥/gim, "۵");
      str1 = str1.replace(/٦/gim, "۶");
      str1 = str1.replace(/٧/gim, "۷");
      str1 = str1.replace(/٨/gim, "۸");
      str1 = str1.replace(/٩/gim, "۹");
      return str1;
    },

    english(input) {
      let str1 = this.validateInput(input);
      // تبدیل اعداد فارسی به انگلیسی
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      // تبدیل اعداد عربی به انگلیسی
      str1 = str1.replace(/٠/gim, "0");
      str1 = str1.replace(/١/gim, "1");
      str1 = str1.replace(/٢/gim, "2");
      str1 = str1.replace(/٣/gim, "3");
      str1 = str1.replace(/٤/gim, "4");
      str1 = str1.replace(/٥/gim, "5");
      str1 = str1.replace(/٦/gim, "6");
      str1 = str1.replace(/٧/gim, "7");
      str1 = str1.replace(/٨/gim, "8");
      str1 = str1.replace(/٩/gim, "9");
      return str1;
    },

    arabic(input) {
      let str1 = this.validateInput(input);
      // تبدیل اعداد انگلیسی به عربی
      str1 = str1.replace(/0/gim, "٠");
      str1 = str1.replace(/1/gim, "١");
      str1 = str1.replace(/2/gim, "٢");
      str1 = str1.replace(/3/gim, "٣");
      str1 = str1.replace(/4/gim, "٤");
      str1 = str1.replace(/5/gim, "٥");
      str1 = str1.replace(/6/gim, "٦");
      str1 = str1.replace(/7/gim, "٧");
      str1 = str1.replace(/8/gim, "٨");
      str1 = str1.replace(/9/gim, "٩");
      // تبدیل اعداد فارسی به عربی
      str1 = str1.replace(/۰/gim, "٠");
      str1 = str1.replace(/۱/gim, "١");
      str1 = str1.replace(/۲/gim, "٢");
      str1 = str1.replace(/۳/gim, "٣");
      str1 = str1.replace(/۴/gim, "٤");
      str1 = str1.replace(/۵/gim, "٥");
      str1 = str1.replace(/۶/gim, "٦");
      str1 = str1.replace(/۷/gim, "٧");
      str1 = str1.replace(/۸/gim, "٨");
      str1 = str1.replace(/۹/gim, "٩");
      return str1;
    },
    setBreadcrumb(title) {
      this.$store.dispatch(SET_BREADCRUMB, [{ title }]);
    },
    english(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      return str1;
    },
    objectLength(obj) {
      try {
        return Object.keys(obj).length;
      } catch (e) {}
    },
    validatePhone(input) {
      let message = "";

      if (
        !/^[\+]?[(]?[0][-\s\.]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im.test(
          input.phone,
        )
      ) {
        message = i18n.t("filters.messages.invalidPhone");
        // return  i18n.t("filters.messages.invalidPhone");
      } else {
        return true;
      }
      return false;
    },
    coreLandUrl(url) {
      return coreland + `/${url}`;
    },
    price: function (input) {
      try {
        if (typeof input !== "string")
          input = input == null ? "0" : input.toString();
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
    unprice: function (input) {
      try {
        return input.replace(/,/g, "");
      } catch (e) {
        return input;
      }
    },
    permissionStatus(permissionName) {
      this.requestApiPost("abilitiesStatus", { name: permissionName }).then(
        (response) => {
          if (response.data === "show") {
            // window.alert('شما به این بخش دسترسی ندارید!');
            return false;
          }
          // window.alert('done')
          return true;
          // return response.data
        },
      );
    },
    copyInClipboard(input) {
      navigator.clipboard.writeText(input);
      i18n.toast.success(i18n.t("filters.messages.copied"));
    },
  },
  computed: {
    ...mapGetters(["user"]),
    wallet() {
      return this.$store.getters["wallet/wallet"];
    },
  },
};

export { Mixin };

export default {
  install(Vue, options) {
    Vue.mixin(Mixin);
  },
};
